<template>
  <div class="login-view">
    <Toolbar
      title="使用者登入"/>
    <div class="content">
      <Input
        label="使用者帳號"
        hint="請輸入帳號"
        @value="account = $event"/>
      <Input
        label="使用者密碼"
        hint="請輸入密碼"
        type="password"
        @value="password = $event"/>
      <div class="error-message">{{errorMessage}}</div>
      <div class=button-warp>
        <Button
          label="登入"
          @click="login"/>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import Toolbar from '@/components/Toolbar.vue'
import Input from '@/components/Input.vue'
import Button from '@/components/Button.vue'
import API from '@/utils/API'

export default defineComponent({
  name: 'Login',
  components: {
    Toolbar,
    Input,
    Button
  },
  data: function () {
    return {
      errorMessage: '',
      account: '',
      password: ''
    }
  },
  methods: {
    login () {
      this.errorMessage = ''
      API.login(this.account, this.password).then(resp => {
        window.localStorage.setItem('access_token', resp.access_token)
        if(resp.password_updated_at !== null && resp.password_updated_at !== ''){ 
          alert("上次密碼修改時間：" + resp.password_updated_at)
        }else{
          alert("上次密碼修改時間：" + resp.created_at)
        }
        this.$router.push({ path: 'main' })
      }).catch(e => {
        this.errorMessage = e
      })

      // alert(JSON.stringify(this.$data, null, ' '))
      // this.errorMessage = 'error message!'
    }
  }
})
</script>

<style scoped lang="scss">
  .login-view {
    width: 100vw;
    min-height: 100vh;
    padding-top: 54px;
  }
  .content {
    width: 360px;
    margin: 40px auto;
    > * {
      margin-top: 10px;
    }
    .error-message {
      color: #decc8e;
      font-size: 16px;
      font-weight: 500;
      min-height: 24px;
    }
    .button-warp > * {
      margin: 92px auto 16px auto;
    }
  }
</style>
